<template>

    <div class="js-render-wrapper lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp align-items-stretch main" v-if="renderData.data.length">


            <!-- <template v-if="renderData.showSlider && renderData.data.length">
                <div class="slide-wrapper"  v-for="slideIndex in numberOfSlides">
                    <slot v-for=" (item,index) in getPartialData(slideIndex,cardsPerSlide)"
                        :item="item"
                    >
                    </slot>
                </div>
            </template>


            <div v-else-if="actualRows >= 1 && renderData.data.length" v-for="rowIndex in actualRows" :class="getRowClass">
                <slot v-for=" (item,index) in getPartialData(rowIndex, renderData.cardsPerRow)"
                    :item="item"
                >
                </slot>
            </div> -->


        <slot v-if="renderData.data.length" v-for=" (item,index) in getPartialData(1,renderData.rows * renderData.cardsPerRow)"
              :item="item"
        >
        </slot>
    </div>

</template>

<script>

    export default {
        name: "BasicCardComponentLayout",
        props: ["renderData"],
        computed: {
            actualRows () {
                let rowsNeeded = Math.ceil( this.renderData.amountOfCards / this.renderData.cardsPerRow);
                let actualRows = this.renderData.rows > rowsNeeded ? rowsNeeded : this.renderData.rows;

                return actualRows;
            },
            cardsPerSlide () {
                return this.renderData ? this.renderData.cardsPerRow * this.renderData.rows : 0;
            },
            numberOfSlides () {
                let numberOfSlides = 0;

                numberOfSlides = Math.ceil(this.renderData.amountOfCards / this.cardsPerSlide);

                return numberOfSlides;
            }
        },
        methods : {
            getPartialData (paginationIndex,amount) {
                paginationIndex -= 1; //sub 1 from index in order to get correct array position because starting index is 0
                let arrayStartingIndex = paginationIndex * amount; //find the starting index that we should grab data from
                let itemsIncluded = 0;


                let arr =  this.renderData.data.filter( (item,index) => {
                        if (index >= arrayStartingIndex &&  itemsIncluded <= amount -1 && arrayStartingIndex + itemsIncluded + 1 <= this.renderData.amountOfCards) {
                            itemsIncluded++;
                            return item;
                        }
                });

                return arr;
            }
        }
    }
</script>

